// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"306":"99b85868","974":"c86228f1"}[chunkId] + ".chunk.css";
};